module.exports = __webpack_public_path__ + "img/ditan.842ad439.png";